import NvChart from '../NvChart';

function traits(commands) {
  return [
    {
      type: 'run-command',
      buttonLabel: 'Configure',
      commandName: commands.configure
    },
    {
      id: commands.exportConfig,
      type: 'run-command',
      buttonLabel: 'Export configuration',
      commandName: commands.exportConfig
    },
    {
      id: commands.importConfig,
      type: 'run-command',
      buttonLabel: 'Import configuration',
      commandName: commands.importConfig
    }
  ];
}

function componentDefinition(editor, options) {
  const {commands} = options;

  const {componentType, componentName} = options;
  return {
    extend: 'react-component',
    model: {
      defaults: {
        'custom-name': componentName,
        component: NvChart,
        attributes: {
          settings: '',
        },
        traits: traits(commands),
      },
    },
    isComponent: el => el.tagName === componentType.toUpperCase()
  }
}

export default function (editor, options = {}) {
  editor.Components.addType(options.componentType, componentDefinition(editor, options));
}
